import React from "react";

const Footer = () => {
  return (
    <>
      <footer>
        <div className="container">
          <div className="row">
            <div className="col-12 col-lg-10 mx-auto">
              <div className="row">
                <div className="col-6 col-lg-3">
                  <h2>Company</h2>
                  <ul>
                    <li>
                      <a href="/">Home</a>
                    </li>
                    <li>
                      <a href="/Service">Services</a>
                    </li>
                    <li>
                      <a href="/about">About</a>
                    </li>
                    <li>
                      <a href="/contact">Contact</a>
                    </li>
                  </ul>
                </div>

                {/* <div className="col-6 col-lg-3">
                  <h2>Support</h2>
                  <ul>
                    <li>
                      <a href="#">About</a>
                    </li>
                    <li>
                      <a href="#">About</a>
                    </li>
                    <li>
                      <a href="#">About</a>
                    </li>
                    <li>
                      <a href="#">About</a>
                    </li>
                  </ul>
                </div> */}

                {/* <div className="col-6 col-lg-3">
                  <h2>Services</h2>
                  <ul>
                    <li>
                      <a href="#">About</a>
                    </li>
                    <li>
                      <a href="#">About</a>
                    </li>
                    <li>
                      <a href="#">About</a>
                    </li>
                    <li>
                      <a href="#">About</a>
                    </li>
                  </ul>
                </div> */}

                <div className="col-6 col-lg-3">
                  <h2>Follow Us</h2>
                  {/* <div className="row">
                    <div className="col-3 mx-auto">
                      <a
                        href="https://www.facebook.com/himsingh.hr1/"
                        target="_raj"
                      >
                        <i class="fab fa-facebook-f fontawesome-style"></i>
                      </a>
                    </div> */}

                    {/* <div className="col-3 mx-auto">
                      <a
                        href="https://www.instagram.com/himsingh_raj/"
                        target="_raj"
                      >
                        <i class="fab fa-instagram fontawesome-style"></i>
                      </a>
                    </div> */}

                    <div className="col-3 mx-auto">
                      <a
                        href="https://www.linkedin.com/in/harrylinuxguru/"
                        target="_raj"
                      >
                        <i class="fab fa-linkedin fontawesome-style"></i>
                      </a>
                    </div>

                    <div className="col-3 mx-auto">
                      <a
                        href="https://mobile.twitter.com/harrylinuxguru/"
                        target="_raj"
                      >
                        <i class="fab fa-twitter fontawesome-style"></i>
                      </a>
                    </div>
                  </div>
                </div>
              </div>
              <hr />
              <div className="mt-5">
                <p className="main-hero-para text-center w-100">
                  Copyright @ 2024 HarryLinuxGuru. All rights reserved.
                </p>
              </div>
            </div>
          </div>
        {/* </div> */}
      </footer>
    </>
  );
};

export default Footer;
